import { ApiResult, HttpClient } from "../http.js";
import { PagedTimeTypes } from "../types/time-types.js";

export interface ListTimeTypesQuery {
  page?: number;
  pageSize?: number;
  /** Retired types are hidden by default — a picker should never offer them. */
  includeInactive?: boolean;
}

export interface CreateTimeTypePayload {
  name: string;
  sortOrder: number;
  id?: string;
}

export interface UpdateTimeTypePayload {
  name: string;
  isActive: boolean;
  sortOrder: number;
}

export class TimeTypesApi {
  constructor(private readonly http: HttpClient) {}

  list(query: ListTimeTypesQuery = {}): Promise<ApiResult<PagedTimeTypes>> {
    return this.http.get<PagedTimeTypes>("/api/timetypes", { query: { ...query } });
  }

  create(payload: CreateTimeTypePayload): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/timetypes", { body: payload });
  }

  update(id: string, payload: UpdateTimeTypePayload): Promise<ApiResult<string>> {
    return this.http.put<string>(`/api/timetypes/${encodeURIComponent(id)}`, { body: payload });
  }
}
